export default __webpack_public_path__ + "static/media/user.04b85b06.png";